import { render, staticRenderFns } from "./patientDivision.vue?vue&type=template&id=c21810e8&scoped=true&"
import script from "./patientDivision.vue?vue&type=script&lang=js&"
export * from "./patientDivision.vue?vue&type=script&lang=js&"
import style0 from "./patientDivision.vue?vue&type=style&index=0&id=c21810e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21810e8",
  null
  
)

export default component.exports